import moment from 'moment';
import 'moment/locale/ru'

export const getLocalDate = (date: any, format = 'DD.MM.YYYY / HH:mm') => {
  // moment.locale('ru');
  return moment.utc(date).local().locale('ru').format(format);
};

export const convertFiletoBase = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as any);
    };
    reader.readAsDataURL(file);
  });
};

export const getTip = (id: number) => (tips: { [key: string]: string }) =>
  tips[id] || 'Не найден текст подсказки';

/**
 * 79999999999 => +7 (999) 999-99-99
 */
export const formatPhone = (phone: string) => {
  return phone ? phone.replace(/\+?(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1\u00A0($2)\u00A0$3-$4-$5') : '';
};

/**
 * +79999999999 => 9999999999
 */
export const trimPhone = (phone: string) => {
  return phone ? phone.replace(/\+?(\d{1})(\d{10})/, '$2') : '';
};


/**
 * format phone from `7 (999) 999-99-99` to `9999999999`
 */
export const normalizePhone = (phone: string) => {
  const cleanedPhone = phone.replace(/[^\d]/g, "");
  return cleanedPhone;
  // return cleanedPhone ? cleanedPhone.replace(/\+?(\d{1})(\d{10})/, '$2') : '';
};

export const fullName = (firstName = '', secondName = '', patronymic = '') => {
  return `${secondName} ${firstName} ${patronymic}`;
};

export const normalizePrice = (price: number) => {
  return isFinite(price) && price !== null ? price.toLocaleString("ru-RU", { style: 'decimal', maximumFractionDigits : 2, minimumFractionDigits : 0 }) : 0;
}

export const getPureDate = (date: any, format?: string) => {
  return moment(date).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  }).format(format)
};

export const setEmptyValuesToNull = (values: {[key: string]: any}) => {
  let updatedValues: {[key: string]: any} = {};
  for (let key in values) {
    if (values[key] === '' || values[key] === undefined) {
      updatedValues[key] = null;
    } else {
      updatedValues[key] = values[key];
    }
  }
  return updatedValues
};

export const getPrice = (price: number, topDiscountPct: number) =>
  Math.round(price * (1 - topDiscountPct / 100) * 100) / 100;

export const getBonus = (
  price: number,
  agentFeePtc: number,
  agentFeeRub: number,
  topAgentFeePtc: number,
  refIncreasePct: number,
  quantity: number = 1,
  discount: number = 0,
) => {
  const refIncrease = Math.round(price * refIncreasePct * quantity) / 100;
  const agentFee = getAgentFee(price, agentFeePtc, agentFeeRub, quantity)
  const topAgentFee = getTopAgentFee(price, topAgentFeePtc, quantity)
  const bonus = Math.round((agentFee + topAgentFee + refIncrease - discount) * 100) / 100;
  return bonus;
};

export const getAgentFee = (
  price: number,
  agentFeePtc: number,
  agentFeeRub: number,
  quantity: number = 1,
) =>
  agentFeeRub ?
    agentFeeRub * quantity
    : Math.round(price * agentFeePtc * quantity) / 100;

export const getTopAgentFee = (
  price: number,
  topAgentFeePtc: number,
  quantity: number = 1,
) =>
  Math.round(price * topAgentFeePtc * quantity) / 100;
